import { Close } from "@mui/icons-material";
import {
  FormControl,
  IconButton,
  InputLabel,
  Select as MUISelect,
  SelectProps,
} from "@mui/material";

type Props = SelectProps & {
  onValueChange: (v: any) => void;
  clearable?: boolean;
};

const Select = ({
  onValueChange,
  label,
  clearable = false,
  ...rest
}: Props) => {
  return (
    <div className="relative w-full">
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <MUISelect
          label={label}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          {...rest}
          onChange={(e) => onValueChange(e.target.value)}
          className={`${rest.value && clearable ? "pr-6" : ""}`}
        />
      </FormControl>
      {clearable && (
        <div
          className={`absolute top-1/2 -translate-y-1/2 right-6 !w-auto ${
            rest.value ? "block" : "hidden"
          }`}
        >
          <IconButton size="small" onClick={() => onValueChange("")}>
            <Close className="!text-lg" />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default Select;
